// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { SuccessModalComponent } from 'src/app/modals/success-modal/success-modal.component';
import { emailPattern, namePattern, usPhonePattern } from 'src/app/utils/form-utils';
import { EnrollmentService } from '@services/enrollment.service';
import { SettingsService } from '@services/settings.service';

@Component({
    selector: 'app-request-access-form',
    templateUrl: './request-access-form.component.html',
    styleUrls: ['./request-access-form.component.scss'],
})
export class RequestAccessFormComponent {
    jacketId: string = '';
    isLoading = false;

    requestAccessForm: FormGroup = this.fb.group({
        email: ['', Validators.compose([Validators.required, Validators.maxLength(500), Validators.pattern(emailPattern)])],
        firstName: ['', Validators.compose([Validators.required, Validators.maxLength(128), Validators.pattern(namePattern)])],
        lastName: ['', Validators.compose([Validators.required, Validators.maxLength(128), Validators.pattern(namePattern)])],
        mobilePhone: ['', Validators.compose([Validators.required, Validators.pattern(usPhonePattern)])],
    });

    constructor(
        private readonly dialog: MatDialog,
        private readonly fb: FormBuilder,
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        private readonly enrollmentService: EnrollmentService,
        private readonly settingsService: SettingsService
    ) {
        this.route.paramMap.subscribe((args) => {
            this.jacketId = args.get('jacketId');

            if (this.jacketId) {
                const jacket = parseInt(this.jacketId);
                if (jacket) {
                    this.enrollmentService.getEnrollmentInfoFromJacketId$(jacket).subscribe((enrollments) => {
                        if (enrollments?.oemCode) {
                            this.settingsService.setOemCode(enrollments.oemCode);
                        }
                    });
                }
            }
        });
    }

    cancel() {
        this.router.navigateByUrl('/login');
    }

    submit() {
        if (!this.requestAccessForm.valid) {
            return;
        }

        const { firstName, lastName, email, mobilePhone } = this.requestAccessForm.value;
        this.isLoading = true;
        this.enrollmentService.requestAccessByJacketId(this.jacketId, firstName, lastName, email, mobilePhone).subscribe(() => {
            this.isLoading = false;

            this.dialog
                .open(SuccessModalComponent, {
                    width: '700px',
                    closeOnNavigation: true,
                    data: {
                        title: 'Access Request Sent',
                        content: `An email has been sent to your system administrator(s).
<br /><br /><br /><strong>If you have never used EZ DOCS</strong>: A system administrator will create a profile for you at this location and send you a Welcome Message to complete your account set up.
<br /><br /><strong>If you have access to EZ DOCS for another location</strong>: A system administrator will add you to this location and you will have access to it the next time you log in.`,
                        btnText: 'Close',
                    },
                })
                .afterClosed()
                .subscribe(() => {
                    this.router.navigate(['/login']);
                });
        });
    }
}
